import * as React from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormGroup, HelpBlock } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';
import { UpdateType } from './manage-account';

interface IProps {
    updateType: UpdateType,
    userName: string,
    wasSent: boolean,
    isValidCode: boolean,
    isValidTime: boolean,
    onComplete: (code: string) => void,
    onCancel: () => void
}

export const VerifyAuthCode: React.FC<IProps> = (props) => {
    const [code, setCode] = React.useState('');
    const [isDirty, setDirty] = React.useState(false);
    const [isValidCode, setValidCode] = React.useState(true);

    const handleComplete = () => {
        setDirty(true);

        if (code == '') {
            setValidCode(false);
        } else {
            setValidCode(true);
            props.onComplete(code);
        }
    };

    const title = props.updateType == UpdateType.Email ? 'Verify Email Address' : 'Verify Mobile Phone';

    return (
        <>
            {props.wasSent && (props.isValidCode == false || props.isValidTime == false) && (
                <Alert bsStyle='danger'>
                    {props.isValidCode == false && (
                        <div>That code is invalid</div>
                    )}

                    {props.isValidCode == true && props.isValidTime == false && (
                        <div>That code has expired</div>
                    )}
                </Alert>
            )}

            <Alert bsStyle='info'>You are currently logged in as {props.userName}</Alert>

            <div className='well well-sm'>
                <h4 className='heading' style={{ marginTop: 0, marginBottom: 20 }}>{title}</h4>

                {props.updateType == UpdateType.Email ?
                    <p>An email with a verification code has been sent to the email you have provided.  Please enter that code to verify your email.</p>
                    :
                    <p>A text-message with a verification code has been sent to the mobile number you have provided.  Please enter that code to verify your phone number.</p>
                }

                <Form horizontal>
                    <FormGroup>
                        <Col sm={4} componentClass={ControlLabel}>Verification Code:</Col>
                        <Col sm={4}>
                            <MaskedInput
                                mask='111111'
                                placeholder="e.g. 123456"
                                className='form-control'
                                value={code}
                                onChange={(e: React.FormEvent<HTMLInputElement>) => setCode(e.currentTarget.value)}
                            />

                            {isDirty && !isValidCode && (
                                <HelpBlock>
                                    {props.updateType == UpdateType.Email ?
                                        <>Please enter the 6 digit code that we sent to the specified email address</>
                                        :
                                        <>Please enter the 6 digit code that we sent to the specified mobile phone number</>
                                    }
                                </HelpBlock>
                            )}
                        </Col>

                        <Col sm={4}>
                            <Button bsStyle='primary' onClick={handleComplete}>Complete Verification</Button>
                            <Button bsStyle='link' onClick={props.onCancel}>Cancel &amp; Start Over</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        </>
    );
}

export default VerifyAuthCode;